import { Button } from "primereact/button";
import { Chips } from "primereact/chips";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import React, { useRef, useState } from "react";
import { FileUploader, FileUploaderRef } from "../FileUploader";
import { FileDialogProps, validateTags } from "./FileDialogWrapper";


export default function PublicFileUploadDialog(props: FileDialogProps){
    const uploadRef = useRef<FileUploaderRef>() as React.MutableRefObject<FileUploaderRef>;

    const isEdit = !!props.currentFile?.id

    const [fileName, setFileName] = useState<string|undefined>(props.currentFile?.fileName)
    const [fileTags, setFileTags] = useState<string[]>(props.currentFile?.tags ?? []);
    const [desc, setDesc] = useState<string>(props.currentFile?.description ?? "")

    const [locked, setLocked] = useState(false)

    const upload = () => {
        console.warn("upload", fileName, desc, fileTags)
        validateTags(fileTags)
        setLocked(true)
        uploadRef.current!!.upload();
    }

    const onUploaded = () => {
        setFileTags([])
        setDesc("")
        props.setVisible(false);
        setLocked(false)
    }

    const onErrored = () => {
        setLocked(false)
    }


    return <Dialog header="Public file upload"  visible={props.visible} style={{width: '50vw'}} modal onHide={() => {
        props.setVisible(false)
    }}>
        <div className="p-fluid p-formgrid p-grid">
            {/* ===== Table selection ======= */}
            <div className="p-field p-col-12">
                <label>File</label>
                <FileUploader ref={uploadRef}
                              isEdit={isEdit}
                              id={props.currentFile?.id}
                              fileName={fileName}
                              desc={desc}
                              fileTags={fileTags}
                              onSelected={e => setFileName(e.name)}
                              onUploaded={onUploaded}
                              onErrored={onErrored}
                              isPublic={true}
                />
            </div>

            <div className="p-field p-col-12">
                <label>File name</label>
                <InputText value={desc} onChange={e => setFileName(e.target.value)} disabled={isEdit}/>
            </div>

            <div className="p-field p-col-12">
                <label>Description</label>
                <InputText value={desc} onChange={e => setDesc(e.target.value)} disabled={isEdit} />
            </div>

            <div className="p-field p-col-12">
                <label>Tags</label>
                <Chips value={fileTags} onChange={(e) => setFileTags(e.value)} disabled={isEdit} />
            </div>

            <Button label="Upload" icon="pi pi-upload" onClick={upload} disabled={locked} />
        </div>
    </Dialog>
}